<template>
  <v-container fluid>
    <v-card>
      <v-card-text>
        <v-row class="d-flex align-center justify-end px-4">
          <v-btn color="success" @click="openEnforcementOfficerDialog()">
            <v-icon>mdi-plus</v-icon>
            {{ $vuetify.lang.t('$vuetify.ADD_NEW') }}
          </v-btn>
        </v-row>
        <v-data-table
          :headers="[
            {
              text: 'ID',
              align: 'start',
              sortable: false,
              value: 'ID'
            },
            {
              text: $vuetify.lang.t(
                '$vuetify.ENFORCEMENT.ENFORCEMENT_OFFICERS.EMAIL'
              ),
              align: 'start',
              sortable: false,
              value: 'Email'
            },
            {
              text: $vuetify.lang.t(
                '$vuetify.ENFORCEMENT.ENFORCEMENT_OFFICERS.OFFICER_NAME'
              ),
              align: 'start',
              sortable: false,
              value: 'Name'
            },
            {
              text: '',
              align: 'end',
              sortable: false,
              value: 'actions'
            }
          ]"
          :items="enforcementOfficers"
          hide-default-footer
          :items-per-page="-1"
        >
          <template v-slot:item.actions="props">
            <td class="d-flex align-center justify-end">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    @click="openEnforcementOfficerDialog(props.item)"
                    v-on="on"
                  >
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>
                  {{ $vuetify.lang.t('$vuetify.EDIT') }}
                </span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    @click="onEnforcementOfficerDelete(props.item)"
                    v-on="on"
                  >
                    <v-icon small color="error">mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>
                  {{ $vuetify.lang.t('$vuetify.DELETE') }}
                </span>
              </v-tooltip>
              <v-menu offset-y dense>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small v-bind="attrs" v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item
                    @click="onEnforcementOfficerInvite(props.item.ID)"
                  >
                    <v-list-item-title>
                      <v-icon small class="mr-2">mdi-send</v-icon>
                      {{ $vuetify.lang.t('$vuetify.SEND_OWNER_INVITE') }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="resetPassword(props.item)">
                    <v-list-item-title>
                      <v-icon small class="mr-2">mdi-lock-reset</v-icon>
                      {{ $vuetify.lang.t('$vuetify.RESET_PASSWORD') }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="
                      (props.item.PasswordResetLinkUuid &&
                        props.PasswordResetLinkUuid !== '' &&
                        isPasswordResetLinkValid(props.item)) ||
                        (props.item.PasswordResetLink &&
                          props.item.PasswordResetLink !== '')
                    "
                    @click="copyPasswordResetLink(props.item)"
                  >
                    <v-list-item-title>
                      <v-icon small class="mr-2">mdi-clipboard</v-icon>
                      {{ $vuetify.lang.t('$vuetify.COPY_PASSWORD_RESET_LINK') }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </template>
        </v-data-table>
        <v-toolbar color="transparent" class="elevation-0">
          <v-spacer></v-spacer>
          <v-btn
            fab
            color="white"
            x-small
            class="ma-2"
            :disabled="currentPageNumber === 0"
            @click="prevPage()"
          >
            <v-icon color="rgba(0, 0, 0, 0.54)">mdi-menu-left</v-icon>
          </v-btn>
          <v-btn fab color="primary" class="secondary--text" x-small readonly>
            {{ currentPageNumber + 1 }}
          </v-btn>
          <v-btn
            fab
            color="white"
            x-small
            class="ma-2"
            :disabled="!enforcementOfficers.length"
            @click="nextPage()"
          >
            <v-icon color="rgba(0, 0, 0, 0.54)">mdi-menu-right</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-card-text>
    </v-card>
    <EditEnforcementOfficerDialog
      v-if="editEnforcementOfficerDialog"
      :visible="editEnforcementOfficerDialog"
      @close="editEnforcementOfficerDialog = false"
    />
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'EnforcementOfficersTab',
  components: {
    EditEnforcementOfficerDialog: () =>
      import(
        /* webpackChunkName: "EditEnforcementOfficerDialog" */ '@/components/enforcement/EditEnforcementOfficerDialog.vue'
      )
  },
  data() {
    return {
      editEnforcementOfficerDialog: false,
      currentPageNumber: 0,
      pageSize: 11
    }
  },
  computed: {
    ...mapGetters('authentication', ['isGlobalAdmin']),
    ...mapGetters('enforcement', ['enforcementOfficers'])
  },
  async mounted() {
    if (!this.enforcementOfficers.length) {
      await this.getEnforcementOfficers(
        `?page=${this.currentPageNumber}&page_size=${this.pageSize}`
      )
    }
  },
  methods: {
    ...mapActions('enforcement', [
      'getEnforcementOfficers',
      'deleteEnforcementOfficer',
      'inviteEnforcementOfficer'
    ]),
    ...mapMutations('enforcement', ['setSelectedEnforcementOfficer']),
    openEnforcementOfficerDialog(officer) {
      if (officer) {
        this.setSelectedEnforcementOfficer(officer)
      } else {
        this.setSelectedEnforcementOfficer({})
      }
      this.editEnforcementOfficerDialog = true
    },
    onEnforcementOfficerDelete(officer) {
      this.deleteEnforcementOfficer(officer.ID)
    },
    prevPage() {
      if (this.currentPageNumber !== 0) {
        this.currentPageNumber -= 1
        this.getEnforcementOfficers(
          `?page=${this.currentPageNumber}&page_size=${this.pageSize}`
        )
      }
    },
    nextPage() {
      if (this.enforcementOfficers.length) {
        this.currentPageNumber += 1
        this.getEnforcementOfficers(
          `?page=${this.currentPageNumber}&page_size=${this.pageSize}`
        )
      }
    },
    copyToClipboard(value) {
      const tempTextarea = document.createElement('textarea')

      tempTextarea.value = value
      document.body.appendChild(tempTextarea)
      tempTextarea.select()

      try {
        navigator.clipboard.writeText(tempTextarea.value)
        this.$store.commit(
          'app/setSnackbar',
          {
            show: true,
            type: 'success',
            message: 'Link copied to clipboard'
          },
          { root: true }
        )
      } catch (err) {
        this.$store.commit(
          'app/setSnackbar',
          {
            show: true,
            type: 'error',
            message: 'Failed to copy password reset link'
          },
          { root: true }
        )
      }

      document.body.removeChild(tempTextarea)
    },
    copyPasswordResetLink(user) {
      if (!user) return

      if (
        user.PasswordResetLinkUuid &&
        user.PasswordResetLinkUuid !== '' &&
        this.isPasswordResetLinkValid(user)
      ) {
        this.copyToClipboard(
          `https://dashboard.snabb.xyz/reset/${user.PasswordResetLinkUuid}`
        )
      } else {
        if (!user.PasswordResetLink && !user.PasswordResetLink.length <= 0) {
          return
        }
        this.copyToClipboard(user.PasswordResetLink)
      }
    },
    isPasswordResetLinkValid(user) {
      const date = new Date(user.PasswordLinkRequestValidUntil)
      const now = new Date()
      if (date < now) {
        return false
      }
      return true
    },
    onEnforcementOfficerInvite(officerId) {
      this.inviteEnforcementOfficer(officerId)
    }
  }
}
</script>
